






























































































































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import {
    listRoles,
    updateRole,
    deleteRole,
    createRole,
    createPermission,
    editPermission,
    listPermissions,
    getPermissionsByRole,
} from "@/services/auth";
import CreatePermission from "@/components/Auth/CreatePermission.vue";
import { isValidPermission, Permission } from "@/models/IPermission";
import { authMixin } from "../../auth/mixins";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button.vue";

@Component({
    components: {
        CreatePermission,
        ebSelect,
        ebButton,
        AtomSpinner,
        ComponentHeader,
    },
})
export default class Role extends Mixins(authMixin) {
    data() {
        return {
            isLoading: false,
            filterCount: 0,
        };
    }
    @Prop(Object) private auth: any;
    striped = false;
    bordered = true;
    filter = "";
    perPage = 10;
    hover = true;
    currentPage = 1;
    small = false;
    dark = false;
    fixed = false;
    private header: string = "Create a Permission";
    private permissions: any[] = [];
    private permission: Permission = {};
    private permissionModal: boolean = false;
    private permissionColumns: any[] = [
        {
            key: "resource",
            label: "Resource",
        },
        {
            key: "name",
            label: "Permission",
        },
        {
            key: "action",
            label: "Method",
        },
        {
            key: "actions",
        },
    ];
    private methods: any[] = [
        {
            label: "GET",
            value: "GET",
        },
        {
            label: "POST",
            value: "POST",
        },
        {
            label: "PUT",
            value: "PUT",
        },
        {
            label: "DELETE",
            value: "DELETE",
        },
    ];

    private async insertPerm(item) {
        const result = await createPermission(item);
        this.permissions.unshift(result.response);
        this.$swal({
            title: "Success",
            text: "Permission created successfully!!",
            type: "success",
        });
        this.$refs["add-permission"].hide();
        this.$refs["permissionComp"].clearRefresh();
    }

    private async hide() {
        this.$refs["add-permission"].hide();
        this.$refs["permissionComp"].clearRefresh();
    }
    private async deletePermission({ item }) {
        await this.$swal({
            title: "Are you sure?",
            text: "You can't revert this action!!",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            type: "warning",
            confirmButtonText: "Delete",
            cancelButtonColor: "#d33",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.$store
                    .dispatch("permission/removePermission", item._id)
                    .then((res: any) => {
                        this.$toasted.success(
                            "Permission deleted successfully!",
                        );
                        this.listAllPermissions();
                    });
            }
        });
    }

    private onFilter(list) {
        this.filterCount = list.length;
        this.currentPage = 1;
    }

    private clearModal() {
        this.permission = {};
        this.permissionModal = false;
    }

    private async handleEdit() {
        try {
            const { name, action, resource } = this.permission;
            if (isValidPermission(this.permission)) {
                const { name, resource, action } = this.permission;
                const payload = {
                    name,
                    resource,
                    action: this.permission.action.value,
                };
                const result = await editPermission(
                    this.permission._id,
                    payload,
                );
                this.permissions = this.permissions.map((p) =>
                    p._id == this.permission._id
                        ? {
                              ...payload,
                              _id: this.permission._id,
                          }
                        : p,
                );
                this.$toasted.success("Permission edited successfully!");
                this.clearModal();
            }
        } catch (err) {
            //
        }
    }

    private editPermission(row) {
        this.permission = {
            ...row.item,
            action: {
                label: row.item.action,
                value: row.item.action,
            },
        };
        this.header = "Edit a Permission";
        this.permissionModal = true;
    }
    private onClickAddPermission() {
        this.$refs["add-permission"].show();
    }

    private reloadData() {
        this.listAllPermissions();
    }

    public async listAllPermissions() {
        this.isLoading = true;
        try {
            const result = await Promise.all([listPermissions()]);
            const { response: permissions } = result[0];
            this.permissions = permissions.reverse();
        } catch (e: any) {
            this.$toasted.error(e.message);
        }
        this.isLoading = false;
    }

    public mounted() {
        this.listAllPermissions();
    }
}
